// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"switch-module--checkbox--35H7K","label":"switch-module--label--1BFyR","button":"switch-module--button--1TRsw"};